import { v4 as uuidv4 } from 'uuid';

export const uuid = () => uuidv4();

export const localId = () => `local-${uuidv4()}`;

export const isLocalId = (id: string) =>
  id.length === 42 && id.startsWith('local-');
